import { Dialog } from "@themes/pollinator/ui/Dialog";
import type { Circle } from "@core/features/circle";
import { TimezoneOption } from "@core/features/timezones";
import type { Meeting } from "@platform/types/platform.types";
import { ProgramCircleParticipant } from "@platform/features/programCircle";

export type Props = {
  circle?: Circle;
  /** Meetings for the user - will be used when meetings feature is implemented */
  meetings?: Meeting[];
  isOpen: boolean;
  onClose: () => void;
  userTimezoneOption: TimezoneOption;
};

/**
 * Dialog to display meeting information.
 * TODO: Update when meetings feature is implemented to show actual meeting data.
 * Currently shows circle participants only.
 */
export function ProgramMeetingInformationDialog({
  circle,
  meetings: _meetings, // TODO: Use when meetings feature is implemented
  isOpen = true,
  onClose,
  userTimezoneOption,
}: Props) {
  if (!userTimezoneOption) return null;
  if (!circle) return null;

  return (
    <Dialog
      title="Circle Participants"
      description="View your circle members"
      isOpen={isOpen}
      onClose={onClose}
      containerClassName="gap-0"
      className="p-0 md:p-0"
      size="4xl"
    >
      <div className="flex flex-row flex-wrap w-full">
        {circle.users?.map((participant) => (
          <ProgramCircleParticipant
            key={participant.id}
            participant={participant}
            className="basis-full md:basis-1/2"
            isWithBio={false}
            isWithEditButton={false}
            isWithWebsite={false}
          />
        ))}
      </div>
    </Dialog>
  );
}

export default ProgramMeetingInformationDialog;

